import { CheckOutlined, GlobalOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { useIntl } from 'react-intl';
import { PressRipple } from '@/components/PressRipple';
import { useChangeLocale } from '@/hooks/useChangeLocale';
import { localeOptions } from '@/locales/config';
import { type AppLocale, useLocaleStore } from '@/stores/localeStore';
import useHeaderActionStyles from './style';

const locales = localeOptions.map(({ key, emoji, label }) => ({
  key,
  emoji,
  label,
}));

export function LangDropdown() {
  const { styles } = useHeaderActionStyles();
  const intl = useIntl();
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useChangeLocale();
  const items: MenuProps['items'] = locales.map((item) => ({
    key: item.key,
    icon:
      item.key === locale ? (
        <CheckOutlined style={{ color: '#52c41a' }} />
      ) : (
        <span style={{ display: 'inline-block', width: 14 }} />
      ),
    label: `${item.emoji} ${item.label}`,
  }));

  return (
    <PressRipple targetSelector="button[data-press-ripple-target]">
      <Dropdown
        placement="bottomRight"
        trigger={['click']}
        popupRender={(menu) => <PressRipple>{menu}</PressRipple>}
        menu={{
          selectedKeys: [locale],
          items,
          style: { minWidth: 180 },
          onClick: ({ key }) => setLocale(key as AppLocale),
        }}
      >
        <Button
          data-press-ripple-target
          type="text"
          className={styles.action}
          style={{ width: 36, border: 0 }}
          aria-label={intl.formatMessage({ id: 'navBar.lang' })}
        >
          <GlobalOutlined />
        </Button>
      </Dropdown>
    </PressRipple>
  );
}
